import { useState } from 'react';
import { MultiIdCombobox } from '@/components/ui/multi-id-combobox';

export const REQUEST_GRID_CLASS =
  'tw:grid tw:grid-cols-[2rem_minmax(8rem,1fr)_minmax(7rem,1fr)_minmax(8rem,1fr)_minmax(12rem,2fr)_auto] tw:items-center tw:gap-2';

const statusOptions = [
  { value: 'draft', label: 'Unsigned draft' },
  { value: 'partially_signed', label: 'Partially signed' },
  { value: 'completed', label: 'Signed' },
];

export const RequestHeaderCard = ({
  setStatusFilter,
}: {
  setStatusFilter: (status: string[]) => void;
}) => {
  const [selected, setSelected] = useState<string[]>([]);

  return (
    <div
      className={`${REQUEST_GRID_CLASS} tw:rounded-xl tw:border tw:border-border tw:bg-card tw:px-3 tw:py-2 tw:text-xs tw:font-medium tw:text-muted-foreground`}
    >
      <div />
      <div>Request Name</div>
      <div>Submitted By</div>
      <div className="tw:min-w-0">
        <div className="tw:mb-1">Status</div>
        <MultiIdCombobox
          options={statusOptions}
          value={selected}
          onChange={(next) => {
            setSelected(next);
            setStatusFilter(next);
          }}
          placeholder="All statuses"
        />
      </div>
      <div>Resources</div>
      <div>Actions</div>
    </div>
  );
};
